export const EDIT = 'edit';
export const DELETE = 'delete';
export const IGNORE = 'ignore';
